<template>
  <svg :class="top?'m-1':''" class=" flex-shrink-0 w-6 h-6 text-primary-600 " :fill="color" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
  </svg>
</template>

<script setup>
defineProps({
  color: String,
  top:Boolean
});
</script>